export default "__VITE_ASSET__CK3_mByX__"